import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable, map} from 'rxjs';
import {ISMEMBER_BASE_URL} from '../config';

export interface MemberQueryParams {
  isDeleted?: 'N' | 'Y' | '';
  pageNumber?: number | null;
  pageSize?: number | null;
  sortBy?: string | null;
  sortDirection?: number | null;
  search?: string | null;
  hasBp2mi?: boolean | null;
  isPay88Member?: boolean | null;
  name?: string | null;
  passportNumber?: string | null;
  phoneNumber?: string | null;
  arcNumber?: string | null;
  address?: string | null;
  groupId?: string | null;
  agentNumber?: string | null;
  uids?: string[] | null;
}

export interface MembersProfile {
  body?: MemberProfile[];
  totalData: number;
}

export interface MemberProfile {
  isDeleted?: boolean;
  id: number;
  uid: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  name: string;
  phoneNumber: string;
  arcNumber: string;
  bp2miId: string;
  hasBp2mi: boolean;
  passportNumber: string;
  address: string;
  groupId?: string;
  agentNumber?: string;
  remitUid?: string | null;
}

export interface MemberProfileResponse {
  message?: string;
  body?: MemberProfile;
  error?: string;
}

export interface CustomerGroup {
  id: string;
  name: string;
  priceType: number;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export const GROUP_CATEGORY_PRICE: Record<number, string> = {
  0: 'Normal',
  1: 'Agent',
  2: 'IS Life',
};

export interface CustomerGroupQueryParams {
  pageNumber?: string;
  pageSize?: string;
  customerId: string;
  customerIds: string[];
}

export interface CustomerGroupResponse {
  message?: string;
  body?: CustomerGroup[];
  error?: string;
}
export interface CustomerGroupGetResponse {
  message?: string;
  body: CustomerGroup;
}

@Injectable({
  providedIn: 'root',
})
export class MemberProfileService {
  constructor(
    private http: HttpClient,
    @Inject(ISMEMBER_BASE_URL) private indoposApiUrl: string,
  ) {}
  queryMembers(
      params?: Partial<MemberQueryParams>,
  ): Observable<MembersProfile> {
    return this.http.post<MembersProfile>(
        this.indoposApiUrl + '/ismember/api/v0/staff/members',
        params,
    );
  }
  deleteMember(uid: string): Observable<MemberProfileResponse> {
    return this.http.delete<MemberProfileResponse>(
        this.indoposApiUrl + '/ismember/api/v0/staff/member/' + encodeURIComponent(uid),
    );
  }

  getMemberByPhoneNumber(phone: string): Observable<MemberProfile | null> {
    return this.queryMembers({
      pageNumber: 0,
      pageSize: 1,
      phoneNumber: phone,
      isDeleted: 'N',
    }).pipe(map((res) => res.body?.[0] ?? null));
  }

  getMemberByUid(uid: string): Observable<MemberProfile | null> {
    return this.http
        .get<MemberProfileResponse>(
            this.indoposApiUrl + `/ismember/api/v0/staff/member/${uid}`,
        )
        .pipe(map((res) => res.body ?? null));
  }
  addCustomerToCustomerGroup(
      id: string,
      uid: string,
  ): Observable<MemberProfileResponse> {
    return this.http.post<MemberProfileResponse>(
        this.indoposApiUrl +
        `/ismember/api/v0/staff/member/${uid}/group/${id}/add`,
        {},
    );
  }
  queryCustomerGroups(): Observable<CustomerGroupResponse> {
    return this.http.post<CustomerGroupResponse>(
        this.indoposApiUrl + `/ismember/api/v0/staff/groups`,
        {
          pageNumber: 0,
          pageSize: -1,
        },
    );
  }
  newCustomerGroup(name: string): Observable<MemberProfileResponse> {
    return this.http.post<MemberProfileResponse>(
        this.indoposApiUrl + '/ismember/api/v0/staff/group',
        {
          name: name,
        },
    );
  }
  getCustomerGroup(id: string): Observable<CustomerGroup> {
    return this.http
        .get<CustomerGroupGetResponse>(
            this.indoposApiUrl + `/ismember/api/v0/staff/group/${id}`,
        )
        .pipe(map((res) => res.body));
  }

  updateCustomerGroup(
      id: string,
      s: {
      name: string;
      priceType: number;
    },
  ): Observable<CustomerGroupResponse> {
    return this.http.put<CustomerGroupResponse>(
        this.indoposApiUrl + `/ismember/api/v0/staff/group/${id}`,
        s,
    );
  }

  upsertMember(
      data: Partial<MemberProfile>,
  ): Observable<MemberProfileResponse> {
    return this.http.post<MemberProfileResponse>(
        this.indoposApiUrl + '/ismember/api/v0/staff/member',
        data,
    );
  }
}
